module.exports = __webpack_public_path__ + "static/media/word.2bc3acbd.png";